import React from 'react'
import { Form } from 'react-bootstrap'
import useItems from '../../../hooks/use-locations'

const LabelItem = ({ value = '', onChange =() => {} }) => {
    const [ items ] = useItems()
    if (!items) {
        return null
    }
    return (
        <Form.Control as='select' value={value} onChange={e => onChange(e.target.value)} placeholder='test'>
            <option value=''></option>
            {items.map((item, k) => (<option value={item.id} key={k}>{item.name}</option>))}
        </Form.Control>
    )
}

export default LabelItem